import { SNOOZE_BUYER } from "@lib/graphql/outreach";
import { Clock } from "lucide-react";
import { useState } from "react";
import { useMutation } from "urql";

interface Props {
  buyerId: string;
  onDone?: () => void;
}

export function SnoozePopover({ buyerId, onDone }: Props) {
  const [, snooze] = useMutation(SNOOZE_BUYER);
  const [busy, setBusy] = useState(false);

  const handleSnooze = async () => {
    setBusy(true);
    const until = new Date();
    until.setDate(until.getDate() + 3);
    await snooze({ input: { id: buyerId, snoozedUntil: until.toISOString() } });
    setBusy(false);
    onDone?.();
  };

  return (
    <button
      onClick={handleSnooze}
      disabled={busy}
      className="inline-flex items-center gap-1 rounded-md border border-input-border bg-card px-3 py-1.5 text-xs font-medium text-text-secondary hover:bg-card-hover disabled:opacity-50"
      title="Hide from active buckets for 3 days"
    >
      <Clock size={12} />
      Snooze 3 days
    </button>
  );
}
